import { isUnresolvedLink } from '@contentful-types/index'

import type {
  BuildContentRendererType,
  BaseContentfulEntry,
  GenericContentRendererProps,
} from '@components/renderer/types'
import { Column } from '@components/ui-core/column/column'

export const buildContentRenderer: BuildContentRendererType = contentTypeMap => {
  const ComponentRenderer = (entry: BaseContentfulEntry) => {
    const contentTypeId = entry.sys.contentType?.sys.id
    const Component = contentTypeMap[contentTypeId]
    if (!Component) {
      console.warn(`${contentTypeId} cannot be handled`)
      return null
    }
    return <Component data={entry} />
  }

  const ArrayRenderer = ({ entries }: { entries: BaseContentfulEntry[] }) => (
    <Column gap="2x">
      {entries
        .filter(s => !isUnresolvedLink(s))
        .map(s => (
          <GenericContentRenderer key={`${s.sys.contentType.sys.id}-${s.sys.id}`} data={s} />
        ))}
    </Column>
  )

  const GenericContentRenderer = ({ data }: GenericContentRendererProps) => {
    if (!data) {
      return null
    }

    if (Array.isArray(data)) {
      return <ArrayRenderer entries={data} />
    }

    return ComponentRenderer(data)
  }

  return GenericContentRenderer
}
